import { useAtom } from 'jotai';
import { FormWorkgroupInvitation } from '../../../../../../components/form/compositions/FormWorkgroupInvitation';
import { FramedContent } from '../../../../../../components/framed-content';
import { invitationTextAtom, saveInvitationTextAsDefaultAtom } from '../atoms';

export const MeetingInviteStep1 = () => {
  const [invitation, setInvitation] = useAtom(invitationTextAtom);
  const [saveAsDefault, setSaveAsDefault] = useAtom(saveInvitationTextAsDefaultAtom);
  return (
    <FramedContent>
      <FormWorkgroupInvitation
        headline={'Ok, noch ein paar Worte zu Ihrer Einladung?'}
        subtitle={'Hier können Sie für Teilnehmende einen Einladungstext verfassen.'}
        saveAsDefaultLabel={'Diesen Text als allgemeinen Einladungstext dieses Meetings speichern'}
        formData={{ itemData: { invitation, saveInvitationTextAsDefault: saveAsDefault } }}
        onChange={newState => {
          setInvitation(newState?.itemData?.invitation ?? '');
          setSaveAsDefault(!!newState?.itemData?.saveInvitationTextAsDefault);
        }}
      />
    </FramedContent>
  );
};
